module.exports = __webpack_public_path__ + "assets/lessons/hr/lesson7/modals/lesson_7_2_a.pdf";